export default __webpack_public_path__ + "4a2009d832436f42b46dad63a677e3bc.jpg";